import React from 'react';
import PropTypes from 'prop-types';
import SubmitTableRow from './SubmitTableRow';

/**
 * @typedef {import('../../types/Assignments').Assignment} Assignment
 */

/**
 * SubmitTable component - displays assignments in a HTML table.
 * @param {Object} props
 * @param {Assignment[]} props.assignmentsList - List of assignments to display.
 * @returns {JSX.Element}
 */
export function SubmitTable({ assignmentsList }) {
  return (
    <div className="table">
      <table>
        <thead>
          <tr>
            <th>Type</th>
            <th>Name</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {assignmentsList.map(assignment => (
            <SubmitTableRow key={assignment.id} assignment={assignment} />
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan="3">Total Devices Selected: {assignmentsList.length}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

SubmitTable.propTypes = {
  assignmentsList: PropTypes.array.isRequired,
};
